import {of as observableOf, Observable} from 'rxjs';
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import {HttpClient} from "@angular/common/http";

export const CommentsResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const http = inject(HttpClient);
    const isNationalTeamPage = !!route.queryParams['isNationalTeamPage'];

    if (!isNationalTeamPage) {
        return http.get('/api/v1/pages/' + route.params['pageID'] + '/comments');
    } else {
        // There is no comment functionality needed for national teams pages
        return observableOf({});
    }
}
